var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelLinkedin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M15.69 8.571c2.463 0 4.31 1.597 4.31 5.026V20h-3.744v-5.974c0-1.5-.541-2.525-1.896-2.525-1.035 0-1.65.69-1.921 1.357-.1.24-.124.572-.124.906V20H8.571v-.094c.006-1.022.047-10.084 0-11.072h3.744v1.582c.497-.76 1.387-1.845 3.375-1.845m-8.261 0V20H4V8.571zM5.724 4c1.043 0 1.685.74 1.705 1.714 0 .952-.662 1.715-1.725 1.715h-.02C4.662 7.429 4 6.666 4 5.714 4 4.74 4.682 4 5.724 4"
})));
export default SvgGemChannelLinkedin;